module.exports = __webpack_public_path__ + "69bab834a89f3ae8c5cd17feea3190c5.svg";